'use client';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { ReactNode } from 'react';

interface PayPalProviderProps {
  children: ReactNode;
}

/**
 * PayPal SDK Provider Component
 *
 * Wraps the application with PayPal JavaScript SDK
 * Uses the client ID from environment variables
 */
export function PayPalProvider({ children }: PayPalProviderProps) {
  const clientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;

  if (!clientId) {
    console.error('[PayPalProvider] NEXT_PUBLIC_PAYPAL_CLIENT_ID is not set');
    return <>{children}</>;
  }

  return (
    <PayPalScriptProvider
      options={{
        clientId,
        currency: 'USD',
        intent: 'capture',
        components: 'buttons',
      }}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
}
